module.exports = __webpack_public_path__ + "assets/logo-104x17.eng.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-104x17.eng.png
// module id = 1669
// module chunks = 7